import type { FilterValueInputRenderer } from './FilterRow';
import { MultiSelect } from './inputs/MultiSelect';
import type { SelectOption } from './inputs/selectOptions';

type MultiSelectValueInputSource = {
  options: SelectOption[];
  isLoading: boolean;
  placeholder: string;
  ariaLabel: string;
  testIdPrefix: string;
};

export function multiSelectValueInput({
  options,
  isLoading,
  placeholder,
  ariaLabel,
  testIdPrefix,
}: MultiSelectValueInputSource): FilterValueInputRenderer {
  return function renderMultiSelectValueInput(value, onChange, name) {
    return (
      <MultiSelect
        name={name}
        options={options}
        value={Array.isArray(value) ? value : []}
        loading={isLoading}
        searchable
        inFlowPanel
        size="sm"
        placeholder={placeholder}
        ariaLabel={ariaLabel}
        containerClassName="flex-1 min-w-0"
        onChange={(_, values) => onChange(values)}
        testId={`${testIdPrefix}-${name}`}
      />
    );
  };
}
